// ----- Account Module -----
export const SET_ERRORS = "setErrors";
export const SET_TOKEN = "setToken";
export const SET_USER = "setUser";
export const TOKEN_OUT_OF_DATE = "accountTokenOutOfDate";

// ----- Ui Module -----
export const SET_INVISIBLE_SIDE_BAR = "setInvisibleSideBar";
export const SET_VISIBLE_SIDE_BAR = "setVisibleSideBar";